export const SET_USER_INFO = 'SET_USER_INFO'
export const REMOVE_USER = 'REMOVE_USER'
export const UPDATE_CART_QUANTITY = 'UPDATE_CART_QUANTITY'
export const SAVE_BANK_STATUS = 'SAVE_BANK_STATUS'
export const SAVE_UPDATE_PCODE = 'SAVE_UPDATE_PCODE'
export const SAVE_PAGE = 'SAVE_PAGE'
export const AGENT_SHOW = 'AGENT_SHOW'
export const REMOVE_BANK_CARD = 'REMOVE_BANK_CARD'
export const ADD_ORDER = 'ADD_ORDER'
export const REMOVE_ORDER = 'REMOVE_ORDER'